// theme.ts — light/dark theme switch. Components read CSS variables, so the
// switch is a single data attribute on <html>; the choice persists.

export type Theme = 'light' | 'dark';

const KEY = 'piq.ui.theme';

export function getTheme(): Theme {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === 'dark' || saved === 'light') return saved;
  } catch {
    /* tests */
  }
  return 'light';
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* tests */
  }
}

export function initTheme(): void {
  document.documentElement.dataset.theme = getTheme();
}
